import { ADD_TOAST_MESSAGE } from 'vuex-toast';
import {
  BASE_DOMAIN,
  API_DOMAIN,
  ASSETS_DOMAIN,
  ERROR_EVENT_NOT_FOUND,
  ERROR_EVENT_COMING_SOON,
  INFO_EVENT_PROTECTED,
  ERROR_UNAUTHORIZED,
  WS_API,
} from '@/constants';
import eventService from '@/services/eventService.js';

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

const RESOLUTION_MAP = {
  SD: '720p',
  HD: '1080p',
  UHD: '2160p',
};

const state = () => ({
  event: {
    metadata: {},
    channels: [],
    streamUrl: '',
    videoOnDemandUrl: '',
    securityCodeMatch: true,
  },
});

const getters = {
  event: (actualState) => actualState.event,
  style: (actualState) => actualState.event.metadata.style,
  mode: (actualState) => {
    const mapEventMode = {
      vod: 'MP4',
      comingSoon: 'COMING_SOON',
      live: 'STREAM',
    };
    return mapEventMode[actualState.event.metadata.eventMode];
  },
  streamUrl: (actualState) => actualState.event.streamUrl,
  videoOnDemandUrl: (actualState) => actualState.event.videoOnDemandUrl,
  languages: (actualState) => {
    var languages = actualState.event.channels.map((channel) => {
      return channel.media.language;
    });
    return languages;
  },
  policy: (actualState) => (language) => {
    const selectedChannel = actualState.event.channels.find((channel) => {
      return channel.media.language === language;
    });
    return selectedChannel.policy;
  },
  comingSoonUrl: (actualState) =>
    `${BASE_DOMAIN  }cs/${  actualState.event.metadata.id  }/${  actualState.event.metadata.htmlCsName}`,
  notFoundUrl: () => `${API_DOMAIN  }error/index.html`,
  backgroundImage: (actualState) =>
    `${ASSETS_DOMAIN + actualState.event.metadata.id  }/backgroundImage.svg`,
  popupLogoImage: (actualState) =>
    `${ASSETS_DOMAIN + actualState.event.metadata.id  }/logo.svg`,
  securityCodeMatch: (actualState) => actualState.event.securityCodeMatch,
  wsUrl: (state, getters, rootState, rootGetters) => {
    return `${WS_API 
    }?eventId=${ 
      state.event.metadata.EventId.replace('EVENT#', '')}&languageId=${rootGetters.language}`;},
};

const actions = {
  fetchMetadataEvent({ commit, dispatch }, eventId) {
    return new Promise((resolve, reject) => {
      try {
        eventService
          .getMetadataEvent(eventId)
          .then((response) => {
            if (response.data.metadata) {
              commit('SET_EVENT_METADATA', response.data.metadata);
              if (response.data.metadata.protected) {
                resolve(INFO_EVENT_PROTECTED);
              } else if (response.data.metadata.eventMode === 'comingSoon') {
                reject(ERROR_EVENT_COMING_SOON);
              } else {
                resolve();
              }
            } else {
              reject(ERROR_EVENT_NOT_FOUND);
            }
          })
          .catch((error) => {
            dispatch(ADD_TOAST_MESSAGE, {
              text:
                (error.data || {}).message ||
                'somethings bad happen, please try again later',
              type: 'danger',
            });
            reject(ERROR_EVENT_NOT_FOUND);
          });
      } catch (e) {
        dispatch(ADD_TOAST_MESSAGE, {
          text:
            (e.data || {}).message ||
            'somethings bad happen, please try again later',
          type: 'danger',
        });
        reject();
      }
    });
  },

  fetchChannelsEvent({ commit, dispatch, state }, { eventId, securityCode }) {
    return new Promise((resolve, reject) => {
      try {
        eventService
          .getChannelsEvent(eventId, securityCode)
          .then((response) => {
            if (response.data.channels && response.data.channels.length > 0) {
              commit('SET_EVENT_CHANNELS', response.data.channels);

              if (state.event.metadata.eventMode === 'comingSoon') {
                reject(ERROR_EVENT_COMING_SOON);
              }

              resolve();
            } else {
              reject(ERROR_EVENT_NOT_FOUND);
            }
          })
          .catch((error) => {
            if (error.error) {
              reject(ERROR_UNAUTHORIZED);
            } else {
              reject();
            }
          });
      } catch (e) {
        dispatch(ADD_TOAST_MESSAGE, {
          text:
            (e.data || {}).message ||
            'somethings bad happen, please try again later',
          type: 'danger',
        });
        reject();
      }
    });
  },

  setStreamUrl({ commit, dispatch, state }, language) {
    try {
      const channel = state.event.channels.find((channelItem) => {
        return channelItem.media.language === language;
      });

      const streamUrl = `${BASE_DOMAIN}streaming/${
        state.event.metadata.id
      }/${language}_${RESOLUTION_MAP[channel.media.outResolution]}${
        channel.media.outFR
      }.m3u8?id=${generateUUID()}`;

      commit('SET_STREAM_URL', streamUrl);
    } catch (e) {
      dispatch(ADD_TOAST_MESSAGE, {
        text:
          (e.data || {}).message ||
          'somethings bad happen, please try again later',
        type: 'danger',
      });
    }
  },

  setVideoOnDemandUrl({ commit, dispatch, state }, language) {
    try {
      const mp4Url = `${BASE_DOMAIN}vod/${state.event.metadata.id}/event-${language}.mp4`;

      commit('SET_VIDEO_ON_DEMAND_URL', mp4Url);
    } catch (e) {
      dispatch(ADD_TOAST_MESSAGE, {
        text:
          (e.data || {}).message ||
          'somethings bad happen, please try again later',
        type: 'danger',
      });
    }
  },

  setSecurityCodeMatch({ commit, dispatch }, securityCodeMatch) {
    try {
      commit('SET_SECURITY_CODE_MATCH', securityCodeMatch);
    } catch (e) {
      dispatch(ADD_TOAST_MESSAGE, {
        text:
          (e.data || {}).message ||
          'somethings bad happen, please try again later',
        type: 'danger',
      });
    }
  },
};

const mutations = {
  SET_EVENT_METADATA: (actualState, eventMetadata) =>
    (actualState.event.metadata = eventMetadata),
  SET_EVENT_CHANNELS: (actualState, eventChannels) =>
    (actualState.event.channels = eventChannels),
  SET_STREAM_URL: (actualState, streamUrl) =>
    (actualState.event.streamUrl = streamUrl),
  SET_VIDEO_ON_DEMAND_URL: (actualState, videoOnDemandUrl) =>
    (actualState.event.videoOnDemandUrl = videoOnDemandUrl),
  SET_SECURITY_CODE_MATCH: (actualState, securityCodeMatch) =>
    (actualState.event.securityCodeMatch = securityCodeMatch),
};
export default {
  state,
  getters,
  actions,
  mutations,
};
